import { FormSection } from 'app/components/shared/FormSection'
import { Container } from 'app/components/ui/Container'
import { Location } from 'EstraSponsor'
import React from 'react'

import { CertificationsFormSection } from '../formSections/Certifications'
import { HolderFormSection } from '../formSections/Holder'
import { HolderWrapper } from '../formSections/HolderWrapper'
import { PrimaryBankDetailsFormSection } from '../formSections/PrimaryBankDetails'
import { PrivacyFormSection } from '../formSections/Privacy'
import { SecondaryBankDetailsFormSection } from '../formSections/SecondaryBankDetails'

type Props = {
  locations: Location[]
}

export const AccountingDataInnerForm = ({ locations }: Props): JSX.Element => {
  return (
    <Container>
      <FormSection>
        <CertificationsFormSection />
      </FormSection>
      <FormSection title='Titolare / Legale Rappresentante'>
        <HolderFormSection holderWho='holder_address' locations={locations} />
        <HolderWrapper
          holderWho='technical_director_address'
          checkboxText='Il Titolare / Legale Rappresentante è anche il Direttore Tecnico'
          checkboxFor='fill_technical_director'
          locations={locations}
        />
        <HolderWrapper
          holderWho='technical_manager_address'
          checkboxText='Il Titolare / Legale Rappresentante è anche il Responsabile Tecnico'
          checkboxFor='fill_technical_manager'
          locations={locations}
        />
      </FormSection>
      <PrimaryBankDetailsFormSection></PrimaryBankDetailsFormSection>
      <SecondaryBankDetailsFormSection></SecondaryBankDetailsFormSection>
      <FormSection title='Privacy'>
        <PrivacyFormSection />
      </FormSection>
    </Container>
  )
}
